import i18next from "i18next";
import {DayBar} from "./DayBar";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../../columns";
import {DatetimeHelper} from "../../../../../../utils/DatetimeHelper";

// Los montos llegan formateados del backend: sin escapar, una fecha con «/» saldría como entidad HTML.
const RAW = {interpolation: {escapeValue: false}};

const isPresent = (value) => value !== undefined && value !== null;

export class BudgetDayBar extends DayBar {
    baseCssClasses() {
        const base = `graphic-item`;
        if (this.props.isToday) {
            const fluctuationClass = `-${this.props.fluctuation}`;
            return `${base} -spotlight ${fluctuationClass}`;
        } else {
            return base;
        }
    }

    renderTitle() {
        return [...this.spendingLines(), ...this.budgetLines()].join('\n');
    }

    // El acumulado es lo invertido desde el inicio del período HASTA ese día: se lo nombra como tal,
    // porque como «Gastaste» se leía como el gasto del día (cc#231).
    spendingLines() {
        const {dayNumber, isToday, spentOnThatDay, accumulatedSpent, expectedAccumulatedSpent} = this.props;
        const lines = [i18next.t(isToday ? 'budget_day_bar.today' : 'budget_day_bar.day', {day: dayNumber, ...RAW})];
        // Las filas que el Tablero tiene en caché de antes de este cambio no traen el gasto del día.
        if (isPresent(spentOnThatDay))
            lines.push(i18next.t('budget_day_bar.spent_on_day', {value: spentOnThatDay, ...RAW}));
        lines.push(i18next.t('budget_day_bar.accumulated', {value: accumulatedSpent, ...RAW}));
        if (isPresent(expectedAccumulatedSpent))
            lines.push(i18next.t('budget_day_bar.expected', {value: expectedAccumulatedSpent, ...RAW}));
        return lines;
    }

    budgetLines() {
        if (this.props.rollover) {
            // Con rollover no se mencionan los tramos (como antes).
            return [
                i18next.t('budget_day_bar.rollover_enabled'),
                i18next.t('budget_day_bar.rollover_balance', {value: this.props.balance, ...RAW}),
                i18next.t('budget_day_bar.rollover_allocated', {value: this.props.allocatedBudget, ...RAW}),
            ];
        }
        if (isPresent(this.props.budgetPartialGoalAllocatedBudget)) {
            const date = DatetimeHelper.YYYYMMDDToFriendlyStr(this.props.budgetPartialGoalDate);
            return [i18next.t('budget_day_bar.partial_goal', {value: this.props.budgetPartialGoalAllocatedBudget, date, ...RAW})];
        }
        return [];
    }

    renderCellContent() {
        if(!this.props.isToday)
            return "";

        if(this.props.fluctuationPercentage !== COLUMN_CELL_INVALID_CONTENT)
            return this.props.fluctuationPercentage
        else
            return this.props.accumulatedSpent;
    }
}
